export default "__VITE_ASSET__DUz$vLTF__"